import { makeStyles } from "@material-ui/core";

export const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: 30
  },
  tabs: {
    '& .MuiTab-root': {
      fontSize: '14px', 
      textTransform: 'lowercase',
    },
  },
  disabledIndicator: {
    display: 'none',
  },
}));